import {
  GET_NOTIFICATION_REQUEST,
  GET_NOTIFICATION,
  GET_NOTIFICATION_ERROR,
  NEW_NOTIFICATION_REQUEST,
  NEW_NOTIFICATION,
  NEW_NOTIFICATION_ERROR,
  NEW_NOTIFICATION_CONFIRMATION
} from "../actions/types"

var initialState = {
  item: {},
  loading: true,
  showConfirmation: false,
  error: {}
}

export default function(state = initialState, action) {
  switch (action.type) {
    case NEW_NOTIFICATION_REQUEST:
      return {
        ...state,
        showConfirmation: false,
        loading: action.payload.loading
      }
    case NEW_NOTIFICATION:
      return {
        ...state,
        item: action.payload.notification
      }
    case NEW_NOTIFICATION_ERROR:
      return {
        ...state,
        loading: action.payload.loading,
        error: action.payload.error
      }
    case NEW_NOTIFICATION_CONFIRMATION:
      return {
        ...state,
        loading: action.payload.loading,
        showConfirmation: action.payload.showConfirmation,
        item: action.payload.notification
      }
    case GET_NOTIFICATION_REQUEST:
      return {
        ...state,
        loading: action.payload.loading
      }
    case GET_NOTIFICATION:
      return {
        ...state,
        loading: action.payload.loading,
        item: action.payload.notification
      }
    case GET_NOTIFICATION_ERROR:
      return {
        ...state,
        loading: action.payload.loading,
        error: action.payload.error
      }
    default:
      return { ...state }
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/notification_reducer.js
 **/